// extracted by mini-css-extract-plugin
export default {"wrapper":"FzLDI","map":"Jy0o1","text":"fDHz8"};